export default "__VITE_ASSET__450bf217__"